import { render, staticRenderFns } from "./TrendDispatch.vue?vue&type=template&id=721c2cee&name=trend-dispatch&"
import script from "./TrendDispatch.vue?vue&type=script&lang=js&"
export * from "./TrendDispatch.vue?vue&type=script&lang=js&"
import style0 from "./TrendDispatch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports